/**
 * Copyright 2023 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

export enum NotificationGroupType {
  email = "email",
  slack = "slack",
  pagerDuty = "pagerDuty",
}
